module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00011-fs8.fa98ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00011-fs8.png
// module id = 59
// module chunks = 0